import * as styles from "./RelationSection.css";

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@frontend/components/atoms/Collapsible";
import { Icon } from "@frontend/components/atoms/Icon";
import { useLingui } from "@lingui/react";

import { RelationEntityLabels } from "../../i18n";
import type { RelationLink } from "../../types";
import { RelationItem } from "./RelationItem";
import { entityIcon } from "./entities";

/** Above this, a section starts folded: one entity often holds dozens. */
const FOLDED_ABOVE = 5;

export function RelationSection({
  entity,
  links,
}: {
  readonly entity: string;
  readonly links: RelationLink[];
}) {
  const { _ } = useLingui();

  const label = RelationEntityLabels[entity];

  return (
    <section className={styles.section}>
      <Collapsible
        variant="ghost"
        size="sm"
        defaultOpen={links.length <= FOLDED_ABOVE}
      >
        <CollapsibleTrigger className={styles.trigger}>
          <Icon name={entityIcon(entity)} size="sm" />

          <span className={styles.label}>{label ? _(label) : entity}</span>

          <span className={styles.count}>{links.length}</span>
        </CollapsibleTrigger>

        <CollapsibleContent>
          <ul className={styles.list}>
            {links.map((link) => (
              <RelationItem
                key={`${link.entity}-${link.id}-${link.role}`}
                link={link}
              />
            ))}
          </ul>
        </CollapsibleContent>
      </Collapsible>
    </section>
  );
}
